import { FORM_FIELDS, FORM_FIELDS_NAMES } from './userModalUtils';
import { ISelectorData } from '../../components/application/NewApplication';
import React, { ReactNode } from 'react';
import { ItemDataType } from 'rsuite/CascadeTree';
import { IFormInputProps } from '../../components/merchants/FormInput';
import { InputType } from '../../components/form/form-input-constants';

interface IUserInformation {
	emailAdditionalClasses: string;
	additionalClasses: string;
	isDisabled?: boolean,
	merchantList: ISelectorData[],
	searchBy?: (keyword: string, label: ReactNode, item: ItemDataType<string | number>) => boolean;
	renderMenuItem?: (label: React.ReactNode, item: ItemDataType<string | number>) => React.ReactNode;
}

export const USER_INFORMATION = (props: IUserInformation): IFormInputProps[] => {
	const { emailAdditionalClasses, additionalClasses, isDisabled, merchantList, searchBy, renderMenuItem } = props;
	return [
		{
			key: FORM_FIELDS.FIRST_NAME,
			fieldName: FORM_FIELDS.FIRST_NAME,
			placeholder: FORM_FIELDS_NAMES.FIRST_NAME,
			label: FORM_FIELDS_NAMES.FIRST_NAME,
			inputType: InputType.Text,
			required: true,
			additionalClasses,
			// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
			autoComplete: 'given-name'
		},
		{
			key: FORM_FIELDS.LAST_NAME,
			fieldName: FORM_FIELDS.LAST_NAME,
			placeholder: FORM_FIELDS_NAMES.LAST_NAME,
			label: FORM_FIELDS_NAMES.LAST_NAME,
			inputType: InputType.Text,
			required: true,
			additionalClasses,
			autoComplete: 'family-name'
		},
		{
			key: FORM_FIELDS.EMAIL,
			fieldName: FORM_FIELDS.EMAIL,
			placeholder: FORM_FIELDS_NAMES.EMAIL,
			label: FORM_FIELDS_NAMES.EMAIL,
			inputType: InputType.Text,
			required: true,
			additionalClasses: emailAdditionalClasses,
			readOnly: isDisabled,
			disabled: isDisabled,
			autoComplete: 'email'
		},
		{
			key: FORM_FIELDS.PHONE,
			fieldName: FORM_FIELDS.PHONE,
			placeholder: FORM_FIELDS_NAMES.PHONE,
			label: FORM_FIELDS_NAMES.PHONE,
			inputType: InputType.Phone,
			defaultCountry: 'US',
			required: true,
			additionalClasses,
			autoComplete: 'tel'
		},
		{
			key: FORM_FIELDS.MERCHANT_ID,
			fieldName: FORM_FIELDS.MERCHANT_ID,
			placeholder: FORM_FIELDS_NAMES.MERCHANT_ID,
			label: FORM_FIELDS_NAMES.MERCHANT_ID,
			inputType: InputType.Select,
			data: merchantList,
			required: true,
			disabled: isDisabled,
			renderMenuItem: renderMenuItem,
			searchBy: searchBy,
			additionalClasses,
			autoComplete: 'organization'
		}
	];
};
